import React from "react";

import { SignalCellularAlt } from "@mui/icons-material";

import CircularProgress from "veneer/CircularProgress";
import Stack from "veneer/Stack";
import styled from "veneer/styled";
import { Colors } from "veneer/Theme";
import Tooltip from "veneer/Tooltip";
import Typography from "veneer/Typography";

interface WsOnlineStatusProps {
  online: boolean;
}

const ErrorCircularProgress = styled(CircularProgress)({
  color: Colors.red700,
});

function WsOnlineStatus({ online }: WsOnlineStatusProps) {
  const config = online
    ? {
        title: "You are online and connected.",
        icon: <SignalCellularAlt color="success" data-testid="online-icon" />,
        label: "Online",
      }
    : {
        title: "Attempting to reconnect to the server...",
        icon: <ErrorCircularProgress data-testid="offline-spinner" size={12} />,
        label: "Offline",
      };

  return (
    <Tooltip title={config.title}>
      <Stack alignItems="center" direction="row" spacing={0.5}>
        {config.icon}
        <Typography variant="body2">{config.label}</Typography>
      </Stack>
    </Tooltip>
  );
}

export { WsOnlineStatus };
export default WsOnlineStatus;
